import { Reducer } from 'redux'
import {
  CONFIGURACAO_KANBAN,
  InvalidsRegisterSLAs,
  RegraEscalacao,
  TYPES
} from './types'
import { AnyAction, ArrayElement } from 'models/types'

const INITIAL_STATE: CONFIGURACAO_KANBAN = {
  activeTab: 1,
  tabEtapas: {
    pipelines: [],
    etapasPipeline: [],
    register: null,
    invalids: {
      id: {
        invalid: false,
        message: ''
      },
      nome: {
        invalid: false,
        message: ''
      },
      descricao: {
        invalid: false,
        message: ''
      },
      cor: {
        invalid: false,
        message: ''
      },
      etapasPermitidas: {
        invalid: false,
        message: ''
      },
      pipelineId: {
        invalid: false,
        message: ''
      },
      status: {
        invalid: false,
        message: ''
      }
    },
    etapasPermitidas: [],
    visualizacao: false,
    pipelineSelecionado: null,
    etapaPipelineSelecionado: null
  },
  tabSLAs: {
    bigNumbers: {
      prazosAtendimentosAtivos: 0,
      emAtrasoAtivos: 0
    },
    register: null,
    invalids: {
      id: {
        invalid: false,
        message: ''
      },
      nome: {
        invalid: false,
        message: ''
      },
      descricao: {
        invalid: false,
        message: ''
      },
      prazo: {
        invalid: false,
        message: ''
      },
      regrasEscalacao: [],
      regrasEscalacaoMessage: {
        invalid: false,
        message: ''
      },
      pipelineId: {
        invalid: false,
        message: ''
      },
      pipelineEtapaId: {
        invalid: false,
        message: ''
      }
    },
    etapas: [],
    pipelines: [],
    acoes: [
      {
        id: '16706f32-8a99-40b0-85a1-3e53dc3b5efe',
        descricao: 'Enviar Notificação'
      }
    ],
    visualizacao: false,
    slasConfigurados: []
  },
  tabPipelines: {
    pipelines: [],
    pagination: {
      page: 0,
      pageSize: 10,
      totalRegistros: 0
    },
    register: null,
    invalids: {
      id: {
        invalid: false,
        message: ''
      },
      nomePipeline: {
        invalid: false,
        message: ''
      },
      centroCustoId: {
        invalid: false,
        message: ''
      },
      descricao: {
        invalid: false,
        message: ''
      },
      site: {
        invalid: false,
        message: ''
      }
    },
    search: {
      status: null,
      nome: ''
    },
    modalRegisterIsOpen: false,
    visualizacao: false,
    pipelineSelecionado: null,
    optionsSelect: {
      centrosCusto: []
    }
  }
}

const reducer: Reducer<CONFIGURACAO_KANBAN, AnyAction> = (
  state = INITIAL_STATE,
  action
) => {
  switch (action.type) {
    case TYPES.SET_ACTIVE_TAB:
      return { ...state, activeTab: action.value }
    case TYPES.SET_CONFIGURACAO_KANBAN:
      return { ...state, activeTab: action.value }
    case TYPES.SET_PIPELINES_TAB_ETAPAS:
      return {
        ...state,
        tabEtapas: { ...state.tabEtapas, pipelines: action.value }
      }
    case TYPES.CLEAN_PIPELINES_TAB_ETAPAS:
      return {
        ...state,
        tabEtapas: { ...state.tabEtapas, pipelines: [] }
      }
    case TYPES.SET_ETAPAS_PIPELINES_TAB_ETAPAS:
      return {
        ...state,
        tabEtapas: { ...state.tabEtapas, etapasPipeline: action.value }
      }
    case TYPES.CLEAN_ETAPAS_PIPELINES_TAB_ETAPAS:
      return {
        ...state,
        tabEtapas: { ...state.tabEtapas, etapasPipeline: [] }
      }
    case TYPES.SET_REGISTER_TAB_ETAPAS:
      return {
        ...state,
        tabEtapas: { ...state.tabEtapas, register: action.value }
      }
    case TYPES.SET_REGISTER_FIELDS_TAB_ETAPAS:
      return {
        ...state,
        tabEtapas: {
          ...state.tabEtapas,
          register: {
            ...state.tabEtapas.register,
            [action.field]: action.value
          }
        }
      }
    case TYPES.SET_REGISTER_ETAPAS_PERMITIDAS_TAB_ETAPAS: {
      if (
        !state.tabEtapas.register ||
        !Array.isArray(state.tabEtapas.register.etapasPermitidas)
      ) {
        return {
          ...state,
          tabEtapas: {
            ...state.tabEtapas,
            register: {
              ...(state.tabEtapas.register || {}),
              etapasPermitidas: [action.value]
            }
          }
        }
      }
      const etapasPermitidasAtuais = state.tabEtapas.register.etapasPermitidas
      const etapaJaAdicionada = etapasPermitidasAtuais.find(
        (etapa) => etapa === action.value
      )
      if (etapaJaAdicionada) {
        const etapasPermitidasAtualizadas = etapasPermitidasAtuais.filter(
          (etapa) => etapa !== action.value
        )
        return {
          ...state,
          tabEtapas: {
            ...state.tabEtapas,
            register: {
              ...state.tabEtapas.register,
              etapasPermitidas: etapasPermitidasAtualizadas
            }
          }
        }
      }
      return {
        ...state,
        tabEtapas: {
          ...state.tabEtapas,
          register: {
            ...state.tabEtapas.register,
            etapasPermitidas: [
              ...state.tabEtapas.register.etapasPermitidas,
              action.value
            ]
          }
        }
      }
    }
    case TYPES.CLEAN_REGISTER_TAB_ETAPAS:
      return {
        ...state,
        tabEtapas: {
          ...state.tabEtapas,
          register: null
        }
      }
    case TYPES.SET_INVALIDS_FIELDS_REGISTER_TAB_ETAPAS:
      return {
        ...state,
        tabEtapas: {
          ...state.tabEtapas,
          invalids: {
            ...state.tabEtapas.invalids,
            [action.field]: action.value
          }
        }
      }
    case TYPES.CLEAN_INVALIDS_REGISTER_TAB_ETAPAS:
      return {
        ...state,
        tabEtapas: {
          ...state.tabEtapas,
          invalids: {
            id: {
              invalid: false,
              message: ''
            },
            nome: {
              invalid: false,
              message: ''
            },
            descricao: {
              invalid: false,
              message: ''
            },
            cor: {
              invalid: false,
              message: ''
            },
            etapasPermitidas: {
              invalid: false,
              message: ''
            },
            pipelineId: {
              invalid: false,
              message: ''
            },
            ordem: {
              invalid: false,
              message: ''
            },
            status: {
              invalid: false,
              message: ''
            }
          }
        }
      }
    case TYPES.SET_ETAPAS_PERMITIDAS_TAB_ETAPAS:
      return {
        ...state,
        tabEtapas: { ...state.tabEtapas, etapasPermitidas: action.value }
      }
    case TYPES.SET_VISUALIZACAO_TAB_ETAPAS:
      return {
        ...state,
        tabEtapas: { ...state.tabEtapas, visualizacao: action.value }
      }
    case TYPES.SET_PIPELINE_SELECIONADO_TAB_ETAPAS: {
      const pipelineSelecionado =
        state.tabEtapas.pipelineSelecionado === action.value
          ? null
          : action.value
      return {
        ...state,
        tabEtapas: {
          ...state.tabEtapas,
          pipelineSelecionado: pipelineSelecionado,
          etapasPipeline: [],
          etapasPermitidas: []
        }
      }
    }
    case TYPES.SET_ETAPA_PIPELINE_SELECIONADO_TAB_ETAPAS:
      return {
        ...state,
        tabEtapas: {
          ...state.tabEtapas,
          etapaPipelineSelecionado: action.value
        }
      }
    case TYPES.SET_BIGNUMBERS_TAB_SLAS:
      return {
        ...state,
        tabSLAs: {
          ...state.tabSLAs,
          bigNumbers: action.value
        }
      }
    case TYPES.SET_REGISTER_TAB_SLAS:
      return {
        ...state,
        tabSLAs: { ...state.tabSLAs, register: action.value }
      }
    case TYPES.SET_REGISTER_FIELDS_TAB_SLAS:
      return {
        ...state,
        tabSLAs: {
          ...state.tabSLAs,
          register: {
            ...state.tabSLAs.register,
            [action.field]: action.value
          }
        }
      }
    case TYPES.SET_REGISTER_REGRAS_ESCALACAO_TAB_SLAS: {
      if (
        !state.tabSLAs.register ||
        !Array.isArray(state.tabSLAs.register.regrasEscalacao)
      ) {
        return state
      }
      return {
        ...state,
        tabSLAs: {
          ...state.tabSLAs,
          register: {
            ...state.tabSLAs.register,
            regrasEscalacao: state.tabSLAs.register.regrasEscalacao.map(
              (item: RegraEscalacao, idx: number) => {
                if (idx === action.index) {
                  return { ...item, [action.field]: action.value }
                } else {
                  return item
                }
              }
            )
          }
        }
      }
    }
    case TYPES.ADICIONAR_REGISTER_REGRAS_ESCALACAO_TAB_SLAS: {
      if (
        !state.tabSLAs.register ||
        !Array.isArray(state.tabSLAs.register.regrasEscalacao)
      ) {
        return {
          ...state,
          tabSLAs: {
            ...state.tabSLAs,
            register: {
              ...(state.tabSLAs.register || {}),
              regrasEscalacao: [
                {
                  id: '',
                  acaoId: '',
                  disparaEm: '',
                  mensagem: ''
                }
              ]
            },
            invalids: {
              ...state.tabSLAs.invalids,
              regrasEscalacao: [
                {
                  id: {
                    invalid: false,
                    message: ''
                  },
                  acaoId: {
                    invalid: false,
                    message: ''
                  },
                  disparaEm: {
                    invalid: false,
                    message: ''
                  },
                  mensagem: {
                    invalid: false,
                    message: ''
                  }
                }
              ]
            }
          }
        }
      }
      const regrasEscalacaoArray = Object.values(
        state.tabSLAs.invalids.regrasEscalacao
      )
      return {
        ...state,
        tabSLAs: {
          ...state.tabSLAs,
          register: {
            ...state.tabSLAs.register,
            regrasEscalacao: [
              ...state.tabSLAs.register.regrasEscalacao,
              {
                id: '',
                acaoId: '',
                disparaEm: '',
                mensagem: ''
              }
            ]
          },
          invalids: {
            ...state.tabSLAs.invalids,
            regrasEscalacao: [
              ...(regrasEscalacaoArray || []),
              {
                id: {
                  invalid: false,
                  message: ''
                },
                acaoId: {
                  invalid: false,
                  message: ''
                },
                disparaEm: {
                  invalid: false,
                  message: ''
                },
                mensagem: {
                  invalid: false,
                  message: ''
                }
              }
            ]
          }
        }
      }
    }
    case TYPES.REMOVER_REGISTER_REGRAS_ESCALACAO_TAB_SLAS: {
      if (
        !state.tabSLAs.register ||
        !Array.isArray(state.tabSLAs.register.regrasEscalacao)
      ) {
        return state
      }
      const regrasAtualizadas = state.tabSLAs.register.regrasEscalacao.filter(
        (_, idx: number) => idx !== action.index
      )
      const regrasEscalacaoArray = Object.values(
        state.tabSLAs.invalids.regrasEscalacao
      )
      const invalidsAtualizados = (regrasEscalacaoArray || []).filter(
        (_, idx: number) => idx !== action.index
      )
      return {
        ...state,
        tabSLAs: {
          ...state.tabSLAs,
          register: {
            ...state.tabSLAs.register,
            regrasEscalacao: regrasAtualizadas
          },
          invalids: {
            ...state.tabSLAs.invalids,
            regrasEscalacao: invalidsAtualizados
          }
        }
      }
    }
    case TYPES.CLEAN_REGISTER_TAB_SLAS:
      return {
        ...state,
        tabSLAs: {
          ...state.tabSLAs,
          register: null
        }
      }
    case TYPES.SET_INVALIDS_REGISTER_TAB_SLAS:
      return {
        ...state,
        tabSLAs: {
          ...state.tabSLAs,
          invalids: action.value
        }
      }
    case TYPES.SET_INVALIDS_FIELDS_REGISTER_TAB_SLAS:
      return {
        ...state,
        tabSLAs: {
          ...state.tabSLAs,
          invalids: {
            ...state.tabSLAs.invalids,
            [action.field]: action.value
          }
        }
      }
    case TYPES.SET_INVALIDS_FIELDS_REGISTER_ARRAY_TAB_SLAS: {
      const field = action.field as keyof InvalidsRegisterSLAs
      const array = state.tabSLAs.invalids[field] as ArrayElement<
        InvalidsRegisterSLAs[typeof field]
      >[]
      return {
        ...state,
        tabSLAs: {
          ...state.tabSLAs,
          invalids: {
            ...state.tabSLAs.invalids,
            [field]: array.map((x, idx) => {
              if (idx === action.index) {
                return {
                  ...x,
                  [action.nestedField]: action.value
                }
              }
              return x
            })
          }
        }
      }
    }
    case TYPES.CLEAN_INVALIDS_REGISTER_TAB_SLAS: {
      const regrasEscalacaoArray = Object.values(
        state.tabSLAs.invalids.regrasEscalacao
      )
      return {
        ...state,
        tabSLAs: {
          ...state.tabSLAs,
          invalids: {
            id: {
              invalid: false,
              message: ''
            },
            nome: {
              invalid: false,
              message: ''
            },
            descricao: {
              invalid: false,
              message: ''
            },
            etapa: {
              invalid: false,
              message: ''
            },
            prazo: {
              invalid: false,
              message: ''
            },
            regrasEscalacao: [
              ...(regrasEscalacaoArray || []).map(() => ({
                id: {
                  invalid: false,
                  message: ''
                },
                acaoId: {
                  invalid: false,
                  message: ''
                },
                disparaEm: {
                  invalid: false,
                  message: ''
                },
                mensagem: {
                  invalid: false,
                  message: ''
                }
              }))
            ],
            regrasEscalacaoMessage: {
              invalid: false,
              message: ''
            },
            pipelineId: {
              invalid: false,
              message: ''
            },
            pipelineEtapaId: {
              invalid: false,
              message: ''
            }
          }
        }
      }
    }
    case TYPES.SET_ETAPAS_TAB_SLAS:
      return {
        ...state,
        tabSLAs: { ...state.tabSLAs, etapas: action.value }
      }
    case TYPES.SET_PIPELINES_TAB_SLAS:
      return {
        ...state,
        tabSLAs: { ...state.tabSLAs, pipelines: action.value }
      }
    case TYPES.SET_ACOES_TAB_SLAS:
      return {
        ...state,
        tabSLAs: { ...state.tabSLAs, acoes: action.value }
      }
    case TYPES.SET_VISUALIZACAO_TAB_SLAS:
      return {
        ...state,
        tabSLAs: { ...state.tabSLAs, visualizacao: action.value }
      }
    case TYPES.SET_SLAS_CONFIGURADOS_TAB_SLAS:
      return {
        ...state,
        tabSLAs: { ...state.tabSLAs, slasConfigurados: action.value }
      }
    case TYPES.CLEAN_SLAS_CONFIGURADOS_TAB_SLAS:
      return {
        ...state,
        tabSLAs: { ...state.tabSLAs, slasConfigurados: [] }
      }
    case TYPES.SET_PIPELINES_TAB_PIPELINES:
      return {
        ...state,
        tabPipelines: { ...state.tabPipelines, pipelines: action.value }
      }
    case TYPES.SET_PAGINATION_TAB_PIPELINES:
      return {
        ...state,
        tabPipelines: {
          ...state.tabPipelines,
          pagination: {
            ...state.tabPipelines.pagination,
            [action.field]: action.value
          }
        }
      }
    case TYPES.CLEAN_PIPELINES_TAB_PIPELINES:
      return {
        ...state,
        tabPipelines: { ...state.tabPipelines, pipelines: [] }
      }
    case TYPES.SET_REGISTER_TAB_PIPELINES:
      return {
        ...state,
        tabPipelines: { ...state.tabPipelines, register: action.value }
      }
    case TYPES.SET_REGISTER_FIELDS_TAB_PIPELINES:
      return {
        ...state,
        tabPipelines: {
          ...state.tabPipelines,
          register: {
            ...state.tabPipelines.register,
            [action.field]: action.value
          }
        }
      }
    case TYPES.CLEAN_REGISTER_TAB_PIPELINES:
      return {
        ...state,
        tabPipelines: {
          ...state.tabPipelines,
          register: null
        }
      }
    case TYPES.SET_VISUALIZACAO_TAB_PIPELINES:
      return {
        ...state,
        tabPipelines: {
          ...state.tabPipelines,
          visualizacao: action.value
        }
      }
    case TYPES.SET_INVALIDS_FIELDS_REGISTER_TAB_PIPELINES:
      return {
        ...state,
        tabPipelines: {
          ...state.tabPipelines,
          invalids: {
            ...state.tabPipelines.invalids,
            [action.field]: action.value
          }
        }
      }
    case TYPES.CLEAN_INVALIDS_REGISTER_TAB_PIPELINES:
      return {
        ...state,
        tabPipelines: {
          ...state.tabPipelines,
          invalids: {
            id: {
              invalid: false,
              message: ''
            },
            nomePipeline: {
              invalid: false,
              message: ''
            },
            centroCustoId: {
              invalid: false,
              message: ''
            },
            descricao: {
              invalid: false,
              message: ''
            },
            site: {
              invalid: false,
              message: ''
            }
          }
        }
      }
    case TYPES.SET_PIPELINE_SELECIONADO_TAB_PIPELINES:
      return {
        ...state,
        tabPipelines: {
          ...state.tabPipelines,
          pipelineSelecionado: action.value
        }
      }
    case TYPES.CLEAN_PIPELINE_SELECIONADO_TAB_PIPELINES:
      return {
        ...state,
        tabPipelines: {
          ...state.tabPipelines,
          pipelineSelecionado: null
        }
      }
    case TYPES.SET_SEARCH_TAB_PIPELINES:
      return {
        ...state,
        tabPipelines: {
          ...state.tabPipelines,
          search: { ...state.tabPipelines.search, [action.field]: action.value }
        }
      }
    case TYPES.CLEAN_SEARCH_TAB_PIPELINES:
      return {
        ...state,
        tabPipelines: {
          ...state.tabPipelines,
          search: { status: null, nome: '' }
        }
      }
    case TYPES.SET_MODAL_REGISTER_IS_OPEN_PIPELINES:
      return {
        ...state,
        tabPipelines: {
          ...state.tabPipelines,
          modalRegisterIsOpen: action.value
        }
      }
    case TYPES.SET_OPTIONS_SELECT_TAB_PIPELINES:
      return {
        ...state,
        tabPipelines: {
          ...state.tabPipelines,
          optionsSelect: {
            ...state.tabPipelines.optionsSelect,
            [action.field]: action.value
          }
        }
      }
    default:
      return state
  }
}

export default reducer
